import AppDispatcher from '../dispatcher/AppDispatcher';
import { ActionTypes } from '../constants/AppConstants';
import RailcardsService from '../services/RailcardsService';

const RailcardsActions = {

    async load({ smartcard }) {
        AppDispatcher.dispatch({ actionType: ActionTypes.RAILCARDS_LOAD_STARTED });
        try {
            const railcards = await RailcardsService.getAll({ smartcard });
            AppDispatcher.dispatch({
                railcards, smartcard,
                actionType: ActionTypes.RAILCARDS_LOADED
            });
            return railcards;
        } catch (error) {
            AppDispatcher.dispatch({ actionType: ActionTypes.RAILCARDS_LOAD_FAILED });
            throw error;
        }
    },

    async loadAccountDRC(userId) {
        try {
            const railcards = await RailcardsService.getAccountDRC(userId);
            AppDispatcher.dispatch({
                railcards,
                actionType: ActionTypes.ACCOUNT_DRC_LOADED
            });

            return railcards;
        } catch (error) {
            throw (error);
        }
    },

    async setFavouriteDRC(userId, railcardId) {
        try {
            RailcardsService.setFavouriteDRC(userId, railcardId).then(() => {
                AppDispatcher.dispatch({
                    railcardId,
                    actionType: ActionTypes.SET_FAVOURITE_DRC
                });
            });
        } catch (error) {
            throw error;
        }
    },

    async removeDRCDevice(userId, railcardId, body) {
        try {
            RailcardsService.removeDRCDevice(userId, railcardId, body).then(() => {
                AppDispatcher.dispatch({
                    ...body,
                    railcardId,
                    actionType: ActionTypes.REMOVED_DRC_DEVICE
                });
            });
        } catch (error) {
            throw error;
        }
    }
};

export default RailcardsActions;



// WEBPACK FOOTER //
// ./src/actions/RailcardsActions.js